module.exports = __webpack_public_path__ + "static/media/leaseRevenueActive.bb250fcb.png";